module.exports = __webpack_public_path__ + "img/jk_icon_gongzuoshigongchengjikenormal.8da0238b.png";